import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import { $static } from "./src/tools/helpers";

i18n
	.use(Backend)
	.use(initReactI18next)
	.init({
		debug: false,
		fallbackLng: "en",
		supportedLngs: ["ca", "de", "en", "es", "fr", "it", "pt", "ru"],
		interpolation: {
			escapeValue: false,
		},
		ns: ["common"],
		defaultNS: "common",
		backend: {
			loadPath: $static("/assets/locales/{{lng}}/{{ns}}.json"),
		},
	});

export default i18n;
